var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error dts for react-transition-group is not up to date
import { Transition } from 'react-transition-group';
import styled from 'styled-components';
export var Reveal = function (_a) {
    var height = _a.height, children = _a.children, timeout = _a.timeout, rest = __rest(_a, ["height", "children", "timeout"]);
    return (_jsx(Transition, __assign({ timeout: timeout }, rest, { children: _jsx(Wrapper, { timeout: timeout, height: height, children: children() }) })));
};
// --------------------------- STYLES --------------------------- //
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition: height ", "ms,\n    height: ", "px,\n    overflow: hidden\n"], ["\n    transition: height ", "ms,\n    height: ", "px,\n    overflow: hidden\n"])), function (props) { return props.timeout; }, function (props) { return props.height; });
var templateObject_1;
